import { KeyValuePair } from "@dffedb/util";

export type Huskeliste = KeyValuePair<number, string>;
